module.exports = __webpack_public_path__ + "static/media/dietetitian.19d3d015.jpeg";